import { render } from "./NoThesisProgramResult.vue?vue&type=template&id=60e617a5"
import script from "./NoThesisProgramResult.vue?vue&type=script&lang=js"
export * from "./NoThesisProgramResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__